import { PortableText } from "@portabletext/react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";
import { slug } from "../../utils/slug";
import { demoteH1Components } from "../../utils/portableTextComponents";

const Listings = ({ data }) => {
  return (
    <section
      id={data.sectionId ?? ""}
      className="bg-slate-100 py-16 md:py-24 xl:py-32"
    >
      <div className="mx-auto px-5 md:px-8 lg:px-12">
        {/* Header Section */}
        <div className="mb-16 lg:mb-20">
          <div className="space-y-6">
            {/* Title and Caption */}
            <div className="space-y-4">
              {data.caption && (
                <span className="inline-block text-logo1 text-sm font-medium uppercase tracking-wider">
                  {data.caption}
                </span>
              )}
              <h2 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-black leading-tight">
                {data.title}
              </h2>
            </div>

            {/* Description */}
            {data._rawDescription && (
              <div className="text-lg text-gray-600 leading-relaxed max-w-3xl">
                <PortableText
                  value={data._rawDescription}
                  components={demoteH1Components}
                />
              </div>
            )}
          </div>
        </div>

        {/* Listings Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.list?.map((item, key) => (
            <article
              key={key}
              className="group bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2"
            >
              {/* Content Section */}
              <div className="p-6 space-y-6">
                {/* Title */}
                <h3 className="text-2xl font-bold text-black group-hover:text-gray-800 transition-colors duration-200 leading-tight">
                  {item.title}
                </h3>

                {/* Icon Section */}
                <div className="relative p-6 bg-gradient-to-br from-gray-50 to-gray-100 group-hover:from-logo1/10 group-hover:to-logo1/5 transition-all duration-300 rounded-lg">
                  <div className="flex items-center justify-center">
                    <div className="w-24 h-24 group-hover:scale-110 transition-transform duration-300">
                      <GatsbyImage
                        image={item.image.asset.gatsbyImageData}
                        alt={item.title}
                        className="w-24 h-24 object-contain"
                      />
                    </div>
                  </div>
                </div>

                {/* Description */}
                <p className="text-lg text-gray-600 leading-relaxed">
                  {item.description}
                </p>

                {/* Learn More Indicator */}
                {/* <div className="flex items-center pt-2 opacity-0 group-hover:opacity-100 transition-all duration-200 transform translate-y-2 group-hover:translate-y-0">
                  <span className="text-base font-medium text-logo1">
                    Learn More
                  </span>
                  <svg
                    className="ml-2 w-4 h-4 text-logo1 transform group-hover:translate-x-1 transition-transform duration-200"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div> */}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Listings;
